<template>
  <PopupTemplate
    v-if="show"
    class="confirm-popup"
    v-on="$listeners"
    @close="onClose"
  >
    <div class="exclude-popup__container">
      <div class="text-xl font-bold">Включить ЛМСЗ в информирование?</div>
      <div class="mb-6 mt-2">
        После включения ЛМСЗ в информирование, ЛМСЗ будет доступна гражданам для просмотра на портале ЕПГУ.
        Проверьте корректность соотнесения ЛМСЗ с жизненным событием и выбранные условия.
      </div>
      <div class="mt-12 flex flex-row">
        <BaseButton class="mr-4" size="sm" variant="blue" @click="onSave">
          Включить
        </BaseButton>
        <BaseButton
          class="mr-4"
          size="sm"
          variant="blue-transparent"
          @click="onClose"
        >
          Вернуться к редактированию
        </BaseButton>
      </div>
      <div class="mt-6">
        <BaseCheckbox label="Больше не показывать" v-model="neverShow" />
      </div>
    </div>
  </PopupTemplate>
</template>

<script>
  import PopupTemplate from './PopupTemplate';
  import BaseButton from '@/components/global/base-button';
  import BaseCheckbox from '@/components/global/base-checkbox';

  export default {
    name: 'LMSPConfirmPopup',

    components: {
      BaseButton,
      BaseCheckbox,
      PopupTemplate,
    },

    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        neverShow: false,
      };
    },

    methods: {
      onSave() {
        this.$emit('save', {neverShow: this.neverShow});
        this.onClose();
      },
      onClose() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .confirm-popup {
    &__container {
      width: rem(500px);
    }
  }
</style>
